<template>
    <div class="d-grid gap-3 my-1">
        <pc-expand-list
            v-bind:header="errorHeader"
            v-bind:items="errors"
            hide-if-empty
            use-bullets
            data-test-role="importResultErrors" />
        <pc-expand-list
            v-bind:header="warningHeader"
            v-bind:items="warnings"
            hide-if-empty
            use-bullets
            data-test-role="importResultWarnings" />
        <pc-expand-list
            v-bind:header="logHeader"
            v-bind:items="logs"
            v-bind:hide-if-empty="!showEmptyLogs"
            empty-message="No logs found."
            use-bullets
            data-test-role="importResultLogs" />
    </div>
</template>
<script>
    export default {
        props: {
            resultModel: { type: Object, required: false, default: null },
            logHeader: { type: String, required: false, default: "Logs:" },
            warningHeader: { type: String, required: false, default: "Warnings:" },
            errorHeader: { type: String, required: false, default: "Errors:" },

            // Generally we want to hide empty sections, but if we're showing historical
            // logs, we want to indicate that we don't have any logs explicitly
            showEmptyLogs: { type: Boolean, required: false, default: false }
        },
        computed: {
            logs() {
                return this.resultModel && this.resultModel.Logs;
            },
            warnings() {
                return this.resultModel && this.resultModel.Warnings;
            },
            errors() {
                return this.resultModel && this.resultModel.Errors;
            }
        }
    };
</script>
